import styled from "styled-components";

export const Wrapper = styled.div`
  width: 145px;
  height: fit-content;
  max-height: 154px;
  border-radius: 4px;
  border-top: 3px solid #1263DE;
  padding: 14px;
  background-color: #FFFFFF;
  gap: 4px;
  box-shadow: 6px 10px 8px rgba(0, 0, 0, 0.25) ;
`;

export const Head = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 20px
`;

export const Title = styled.div`
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
`;

export const SubTitle = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 12px; 
  line-height: 20px; 
  color: #404040;
  margin-top: 6px;
`;

export const Content = styled.div`
  display: flex;
  align-items: baseline;
  gap: 16px;
`;

export const CharType = styled.span`
  text-align: center;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  background: #EBEEF2;
  color: #4F9BE8;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  text-transform: uppercase;
  margin-right: 8px;
  cursor: default;
`;
